<template>
  <v-menu ref="menu" offset-y max-width="290px" :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        dense
        readonly
        outlined
        required
        event-color="primary"
        prepend-inner-icon="mdi-calendar-outline"
        class="font-size-14"
        data-testid="durationPicker-input-date"
        :rules="rules"
        :error-messages="errorMessage"
        :value="dateRangeText"
        :label="`${$t('common.duration')}*`"
      />
    </template>
    <v-date-picker
      no-title
      range
      reactive
      v-model="dateRange"
      @change="onDateRangeChange($event)"
    />
  </v-menu>
</template>
<script>
import { utils } from 'frontend-js-shared'

export default {
  name: 'DurationPicker',

  props: {
    required: Boolean,
    value: {
      required: false,
      default: () => {
        return []
      },
      type: Array,
    },
  },

  data() {
    return {
      dateRange: [],
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dateRange = val
      },
    },
  },

  computed: {
    dateRangeText() {
      if (!this.value?.[0]?.length) return null
      const formattedValues = this.value.map(val => this.getFormattedDate(val))
      return formattedValues?.join?.(' ~ ')
    },

    dueDateRangeText() {
      return this.getDateRangeText(this.value[1])
    },

    rules() {
      return [
        field =>
          Boolean(field?.length) ||
          this.$t('validation.form.this_field_is_required'),
      ]
    },

    isExpiratedDate() {
      const endDate = this.value[1]

      const todayAtMidnight = new Date().toISOString().slice(0, 10)

      return endDate < todayAtMidnight
    },

    errorMessage() {
      if (!this.value[1]) return ''
      if (this.value[0] > this.value[1])
        return this.$t(
          'error.challenge.start_date_should_be_before_the_finish_date'
        )

      if (this.isExpiratedDate)
        return this.$t(
          'error.challenge.you_cannot_create_challenges_that_closed_in_the_past'
        )
      return ''
    },
  },

  methods: {
    onDateRangeChange(range = []) {
      const [startDate, endDate] = range

      const startDateTime = this.getUTCDate(startDate)
      const endDateTime = this.getUTCDate(endDate)

      const dateRange =
        startDateTime > endDateTime
          ? [endDate, startDate]
          : [startDate, endDate]
      this.$emit('change', dateRange)
    },

    getUTCDate(date) {
      const slashedDate = date.replace(/-/g, '/')
      return new Date(slashedDate).toISOString()
    },

    getFormattedDate(date) {
      if (!date) return null
      const dateToFormat = new Date(date).toISOString().slice(0, -1)
      return utils.dates.formatDate(dateToFormat)
    },
  },
}
</script>
